import { format } from "date-fns";
import {
  Box,
  TableCell,
  TableRow,
  IconButton,
  Typography,
  Avatar,
  Switch,
  CircularProgress,
  Button,
  Modal,
  Checkbox,
  Paper,
  Grid,
  List,
  ListItem,
  ListItemText,
  Rating,
  Divider,
} from "@mui/material";
import { IconDotsVertical, IconEye } from "@tabler/icons";
import CustomCheckbox from "../forms/theme-elements/CustomCheckbox";
import { Fragment, useState } from "react";
import DropDown from "./DropDown";
import { columntype, searchParamsToString } from "src/helper/publicFunction";
import { FaStar, FaStarHalfAlt } from "react-icons/fa";
import { updateStatusOrder } from "src/queries/query";
import DropdownStatus from "../shared/DropdownStatus";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
const RowTable = ({
  row,
  index,
  handleClick,
  onPressItem,
  isSelected,
  Listdropdown,
  columns,
  withOption,
  headCells,
  onPressAnyAction,
  loadingEditdatatype,
  withDeleteItem,
  withEditItem,
  isLogs,
  provided,
  snapshot,
  withViewItem,
  onPressViewItem,
  searchParams,
}) => {
  const queryClient = useQueryClient();
  const [openDropdown, setopenDropdown] = useState(false);
  const [anchorEl, setAnchorEl] = useState(false);
  const isItemSelected = isSelected(row._id);
  const labelId = `enhanced-table-checkbox-${index}`;
  const searchParamsString = searchParams && searchParamsToString(searchParams);
  const { mutate: updateMutate } = useMutation({
    mutationFn: (values) => updateStatusOrder(values),
    onSuccess: () => {
      toast.success("Status updated successfully!");
      queryClient.invalidateQueries({
        queryKey: ["orders", searchParamsString],
      });
      // window.location.reload();
    },
    onError: (error) => {
      toast.error(error?.response?.data?.message ?? `Failed update Status`);
    },
  });

  const onChange = (row, column) => {
    if (!loadingEditdatatype) {
      let newData;
      if (row[column.name] === 1 || row[column.name] === 0) {
        newData = row[column.name] === 1 ? 0 : 1;
      } else if (row[column.name] === true || row[column.name] === false) {
        newData = row[column.name] === true ? false : true;
      } else if (row[column.name] === "true" || row[column.name] === "false") {
        newData = row[column.name] === "true" ? "false" : "true";
      }
      onPressAnyAction(row, column.name, newData);
    }
  };

  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => setOpen(false);

  const loadingComponent = () => {
    return (
      <TableCell>
        <CircularProgress />
      </TableCell>
    );
  };

  return (
    <TableRow
      hover
      role="checkbox"
      aria-checked={isItemSelected}
      tabIndex={-1}
      key={row._id}
      selected={isItemSelected}
      {...provided?.draggableProps} // Apply draggableProps for drag-and-drop
      {...provided?.dragHandleProps} // Apply dragHandleProps for drag-and-drop
      ref={provided?.innerRef}
      sx={{
        backgroundColor: "transparent",
        width: "100%",
        flex: 1,
        color: snapshot.isDragging ? "white" : "black",
        transition: "background-color 0.2s ease",
      }}
    >
      {withDeleteItem ? (
        <TableCell padding="checkbox">
          <CustomCheckbox
            color="primary"
            checked={isItemSelected}
            onChange={() => {
              handleClick(row._id);
            }}
            inputprops={{
              "aria-labelledby": labelId,
            }}
          />
        </TableCell>
      ) : (
        <TableCell padding="checkbox"></TableCell>
      )}

      {headCells.map((title, indexheadCells) => {
        if (title.hide) {
          // eslint-disable-next-line array-callback-return
          return;
        }
        // eslint-disable-next-line array-callback-return
        return columns?.map((column, index) => {
          if (column.type === columntype.time && column.name === title.id) {
            return (
              <TableCell onClick={() => onPressItem(row)}>
                <Typography>
                  {row[column.name]
                    ? format(new Date(row[column.name]), "h:mm a")
                    : "-"}
                </Typography>
              </TableCell>
            );
          } else if (
            column.type === columntype.modalButton &&
            column.name === title.id
          ) {
            const reviewCategories = row?.reviews?.reviewCategories || [];

            return (
              <>
                <TableCell>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={handleOpen}
                  >
                    Show Review Details
                  </Button>
                </TableCell>
                <Modal open={open} onClose={handleClose}>
                  <Box
                    sx={{
                      position: "absolute",
                      top: "50%",
                      left: "50%",
                      transform: "translate(-50%, -50%)",
                      width: { xs: "90%", md: 600 },
                      height: "fit-content",
                      maxHeight: "90%",
                      overflowY: "auto",
                      bgcolor: "background.paper",
                      boxShadow: 24,
                      p: 4,
                      borderRadius: 2,
                    }}
                  >
                    <Typography variant="h5" component="h2" gutterBottom>
                      Review Details
                    </Typography>

                    {reviewCategories.length > 0 ? (
                      <>
                        <Grid
                          container
                          spacing={2}
                          sx={{
                            marginTop: 1,
                            marginBottom: 1,
                          }}
                        >
                          {reviewCategories.map((category, index) => (
                            <Grid item xs={12} sm={6} key={index}>
                              <Paper elevation={3} sx={{ p: 2 }}>
                                <Typography variant="h4" gutterBottom>
                                  {category.reviewCategory}
                                </Typography>
                                <Typography
                                  variant="h6"
                                  sx={{
                                    fontWeight: "normal",
                                    fontSize: "14px",
                                  }}
                                >
                                  {category.comment}
                                </Typography>
                                <List
                                  dense
                                  sx={{
                                    maxHeight: "300px",
                                    overflowY: "auto",
                                  }}
                                >
                                  <Fragment>
                                    {index > 0 && <Divider component="li" />}
                                    <ListItem>
                                      <ListItemText
                                        primary={category.subCatgory}
                                        secondary={
                                          <Rating
                                            name={`rating-${category.subCatgory}`}
                                            value={category.score}
                                            readOnly
                                            size="small"
                                          />
                                        }
                                      />
                                    </ListItem>
                                  </Fragment>
                                </List>
                              </Paper>
                            </Grid>
                          ))}
                        </Grid>
                      </>
                    ) : (
                      <Typography
                        variant="body1"
                        color="textSecondary"
                        sx={{ mt: 2 }}
                      >
                        No review data available.
                      </Typography>
                    )}

                    <Button
                      variant="contained"
                      onClick={handleClose}
                      sx={{ mt: 2 }}
                    >
                      Close
                    </Button>
                  </Box>
                </Modal>
              </>
            );
          } else if (
            column.type === columntype.html &&
            column.name === title.id
          ) {
            return (
              <TableCell onClick={() => onPressItem(row)}>
                <Typography>
                  <div
                    dangerouslySetInnerHTML={{
                      __html: row[column.name],
                    }}
                  />
                </Typography>
              </TableCell>
            );
          } else if (
            column.type === columntype.dateAndtime &&
            column.name === title.id
          ) {
            return (
              <TableCell onClick={() => onPressItem(row)}>
                <Typography>
                  {row[column.name]
                    ? format(new Date(row[column.name]), "E, MMM d yyyy h:mm a")
                    : "-"}
                </Typography>
              </TableCell>
            );
          } else if (
            column.type === columntype.date &&
            column.name === title.id
          ) {
            return (
              <TableCell onClick={() => onPressItem(row)}>
                <Typography>
                  {row[column.name]
                    ? format(new Date(row[column.name]), "E, MMM d yyyy")
                    : "-"}
                </Typography>
              </TableCell>
            );
          } else if (
            column.type === columntype.statusEnum &&
            column.name === title.id
          ) {
            return (
              <TableCell>
                <DropdownStatus
                  order={row}
                  currentStatus={row[column.name]} // Current value
                  onUpdateStatus={(newStatus) => {
                    updateMutate({ id: row._id, status: newStatus }); // Mutate on select
                  }}
                />
              </TableCell>
            );
          } else if (
            column.type === columntype.categories &&
            column.name === title.id
          ) {
            return (
              <TableCell onClick={() => onPressItem(row)}>
                <Typography>
                  {row[column.name] && row[column.name].length > 0
                    ? row[column.name]
                        .map(
                          (subcategory) =>
                            `${subcategory.name}: ${subcategory.score}`
                        )
                        .join(" - ") // Format and join subcategories
                    : "-"}
                </Typography>
              </TableCell>
            );
          } else if (
            column.type === columntype.array &&
            column.name === title.id
          ) {
            return (
              <TableCell onClick={() => onPressItem(row)}>
                <Typography>
                  {row[column.name] && row[column.name].length > 0
                    ? row[column.name].join(" - ") // Join array with " - "
                    : "-"}
                </Typography>
              </TableCell>
            );
          } else if (
            column.type === columntype.image &&
            column.name === title.id
          ) {
            return (
              <TableCell
                onClick={() => onPressItem(row)}
                style={
                  snapshot.isDragging
                    ? {}
                    : {
                        display: "flex",
                        justifyContent: "start",
                        alignContent: "center",
                        marginLeft: "-10px",
                      }
                }
              >
                <Avatar
                  src={
                    row[column.name] && row[column.name] !== "" // Check if image path exists and is not empty
                      ? row[column.name].startsWith("http")
                        ? row[column.name]
                        : `${process.env.REACT_APP_ONLINE_URL}/${
                            row[column.name]
                          }` // Prepend your base URL
                      : null // Fallback to avatar
                  }
                  alt={
                    row?.name
                      ? row?.name
                      : row?.title
                      ? row?.title
                      : row?.username
                      ? row?.username
                      : row[column.name]
                      ? row[column.name]
                      : ""
                  }
                  variant="rounded"
                  sx={{
                    width: 56,
                    height: 56,
                    borderRadius: "100%",
                    margin: 1,
                    backgroundColor: row[column.name]
                      ? "transparent"
                      : "#f5f5f5", // Fallback background color for avatar
                    color: row[column.name] ? "transparent" : "#000", // Color for initials
                  }}
                >
                  {!row[column.name] && row.firstName && row.lastName
                    ? `${row.firstName.charAt(0)}${row.lastName.charAt(0)}` // Show initials if image is not available
                    : ""}
                </Avatar>
              </TableCell>
            );
          } else if (
            column.type === columntype.color && // Check if the type is color
            column.name === title.id
          ) {
            return (
              <TableCell onClick={() => onPressItem(row)}>
                <Box
                  sx={{
                    width: 24, // Set the width of the color box
                    height: 24, // Set the height of the color box
                    borderRadius: "50%", // Make it rounded
                    backgroundColor: `${row[column.name]}` || "#f5f5f5", // Set the color value or a default color
                    border: "1px solid #ddd", // Optional border for better visibility
                  }}
                />
              </TableCell>
            );
          } else if (
            column.type === columntype.rating &&
            column.name === title.id
          ) {
            return (
              <TableCell onClick={() => onPressItem(row)}>
                <Box
                  sx={{
                    display: "flex", // To display stars inline
                    alignItems: "center",
                    gap: 0.5, // Spacing between stars
                  }}
                >
                  {Array.from({ length: 5 }).map((_, index) => {
                    const rating = row[column.name];
                    const roundedRating = Math.floor(rating);
                    const hasHalfStar =
                      rating - roundedRating >= 0.5 &&
                      rating - roundedRating < 0.75;

                    if (index < roundedRating) {
                      return <FaStar key={index} size={20} color="#ffc107" />;
                    } else if (index === roundedRating && hasHalfStar) {
                      return (
                        <FaStarHalfAlt
                          key={index}
                          size={20}
                          color="#ffc107"
                          style={{
                            borderColor: "#e0e0e0",
                          }}
                        />
                      );
                    } else {
                      return <FaStar key={index} size={20} color="#e0e0e0" />;
                    }
                  })}
                </Box>
              </TableCell>
            );
          } else if (
            column.type === columntype.action && // Check if the type is color
            column.name === title.id
          ) {
            const action = row[column.name]?.toUpperCase(); // Ensure action is uppercase
            let actionColor;
            switch (action) {
              case "GET":
                actionColor = "#4caf50";
                break;
              case "POST":
                actionColor = "#2196f3";
                break;
              case "PUT":
                actionColor = "#ff9800";
                break;
              case "DELETE":
                actionColor = "#f44336";
                break;
              default:
                actionColor = "#757575";
            }

            return (
              <TableCell onClick={() => onPressItem(row)}>
                <Box
                  sx={{
                    color: actionColor,
                    fontWeight: "bold",
                    textTransform: "capitalize",
                  }}
                >
                  {action || "No Action"}
                </Box>
              </TableCell>
            );
          } else if (
            column.type === columntype.status &&
            column.name === title.id
          ) {
            return (
              <TableCell onClick={() => onPressItem(row)}>
                <Box
                  display="flex"
                  alignItems="center"
                  width={"fit-content"}
                  padding={1}
                  paddingRight={2}
                  sx={{
                    backgroundColor: row[column.name]
                      ? (theme) => theme.palette.success.main
                      : (theme) => theme.palette.error.main,
                    borderRadius: "8",
                  }}
                >
                  <Typography
                    color="textSecondary"
                    variant="subtitle2"
                    sx={{
                      ml: 1,
                    }}
                  >
                    {row[column.name] === false ? "Off" : "On"}
                  </Typography>
                </Box>
              </TableCell>
            );
          } else if (
            column.type === columntype.check &&
            column.name === title.id
          ) {
            return (
              <TableCell onClick={() => onPressItem(row)}>
                <Box
                  display="flex"
                  alignItems="center"
                  width={"fit-content"}
                  padding={1}
                  paddingRight={2}
                  sx={{
                    backgroundColor: row[column.name]
                      ? (theme) => theme.palette.success.main
                      : (theme) => theme.palette.error.main,
                    borderRadius: "8",
                  }}
                >
                  <Typography
                    color="textSecondary"
                    variant="subtitle2"
                    sx={{
                      ml: 1,
                    }}
                  >
                    {row[column.name] === false ? "No" : "Yes"}
                  </Typography>
                </Box>
              </TableCell>
            );
          } else if (
            column.type === columntype.switch &&
            column.name === title.id
          ) {
            if (loadingEditdatatype === `${row._id}-${column.name}`) {
              return loadingComponent();
            } else {
              return (
                <TableCell>
                  <Switch
                    disabled={!withEditItem}
                    checked={
                      row[column.name] === 1 ||
                      row[column.name] === true ||
                      row[column.name] === "true"
                        ? true
                        : false
                    }
                    onChange={() => {
                      onChange(row, column);
                    }}
                  />
                </TableCell>
              );
            }
          } else if (
            column.type === columntype.checkbox &&
            column.name === title.id
          ) {
            if (loadingEditdatatype === `${row._id}-${column.name}`) {
              return loadingComponent();
            } else {
              return (
                <TableCell>
                  <Checkbox
                    checked={
                      row[column.name] === 1 ||
                      row[column.name] === true ||
                      row[column.name] === "true"
                        ? true
                        : false
                    }
                    onChange={() => {
                      onChange(row, column);
                    }}
                  />
                </TableCell>
              );
            }
          } else if (column.name === title.id) {
            return (
              <TableCell onClick={() => onPressItem(row)}>
                <Typography>
                  {row[column.name] ? row[column.name] : "-"}
                </Typography>
              </TableCell>
            );
          }
        });
      })}
      {withOption &&
      (withEditItem || withDeleteItem) &&
      (!isLogs || row.action_type === "delete") ? (
        <TableCell>
          <IconButton size="small">
            <DropDown
              Listdropdown={Listdropdown}
              open={openDropdown}
              setOpen={setopenDropdown}
              row={row}
              anchorEl={anchorEl}
            />
            <IconDotsVertical
              size="1.1rem"
              onClick={(event) => {
                setAnchorEl(event.currentTarget);
                setopenDropdown(true);
              }}
            />
          </IconButton>
        </TableCell>
      ) : withViewItem ? (
        <TableCell align="center">
          <IconButton onClick={() => onPressViewItem(row)}>
            <IconEye size="1.1rem" />
          </IconButton>
        </TableCell>
      ) : null}
    </TableRow>
  );
};
export default RowTable;
